import { AbstractControl } from '@angular/forms';
import { LocalDateType } from '@app/models';
import { createValidationError, PcsValidationErrors } from '@app/shared/validators/validation-errors';
import { parseToDayjs } from '@util/date-util';


export const timeValueValidator = (val: LocalDateType): PcsValidationErrors | null => {
  if (val) {
    const value = parseToDayjs(val);
    const hour = value.hour();
    const min = value.minute();

    return Number.isNaN(hour) || Number.isNaN(min) ?
      createValidationError('timeFormatError', 'label.error.invalid.time.format')
      : null;
  }
};

export const timeValidator = ((control: AbstractControl): { [key: string]: any } => timeValueValidator(control.value));
